/** User-facing Plans copy (nav/page = Plans; portal action = Manage subscription). */

export const PLAN_NAV_LABEL = "Plans";

export const PLAN_LINK_VIEW = "View plans";
export const PLAN_LINK_VIEW_PRO = "View Pro plan";

export const PLAN_ACTION_MANAGE_SUBSCRIPTION = "Manage subscription";
export const PLAN_ACTION_MANAGE_BILLING = "Manage billing";
export const PLAN_ACTION_CANCEL_SUBSCRIPTION = "Cancel subscription";
export const PLAN_CANCEL_DONE = "Canceled for next month";
export const PLAN_CANCEL_RENEWAL_NOTE =
  "You can cancel next month's renewal only. This month's plan stays active and cannot be canceled.";

export const PLAN_CTA_SUBSCRIBE = "Subscribe";

/** Keeps disabled plan CTA row height aligned with labeled buttons (e.g. Pro on Starter card). */
export const PLAN_CTA_LINE_PLACEHOLDER = "\u00A0";

export const PLAN_LEAD_BROWSE_FREE =
  "Starter is free. Upgrade to Pro on Plans for Bulk Export.";
export const PLAN_LEAD_CONFIRMING = "Confirming your plan\u2026";
export const PLAN_CHECKOUT_WEBHOOK_HINT =
  "Payment confirmation is taking longer than usual. Refresh this page in a moment \u2014 your plan activates once Stripe sends the webhook.";
export const PLAN_CHECKOUT_NEW_TAB_HINT =
  "Stripe opened in a new tab. Complete payment or plan changes there \u2014 this page updates automatically.";
export const PLAN_ERR_POPUP_BLOCKED =
  "Your browser blocked the new tab. Allow pop-ups for this site, or open Stripe below.";
export const PLAN_ACTION_OPEN_BILLING_HERE = "Open Stripe in this tab";

export const PLAN_GATE_SUBSCRIBE_TITLE = "Subscribe to continue";
export const PLAN_GATE_UPGRADE_TITLE = "Upgrade to Pro";

export const PLAN_ERR_UPGRADE_ON_PLANS =
  "This action requires Pro \u2014 upgrade on Plans.";
export const PLAN_ERR_SUBSCRIBE_ON_PLANS =
  "Subscribe on Plans to unlock this action.";
export const PLAN_ERR_SUBSCRIBE_OR_UPGRADE =
  "Subscribe or upgrade on Plans to continue.";
export const PLAN_ERR_REDOWNLOAD =
  "Re-downloads require an active plan \u2014 subscribe on Plans.";

export const PLAN_TOPBAR_LOADING = "Loading plan\u2026";
export const PLAN_TOPBAR_TRIAL_ENDED = "Trial ended \u2014";

export const PLAN_FEATURE_FOOTNOTE =
  "Most features are free on Starter. Only Bulk Export Invoice PDFs requires Pro.";
